import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { PatientSearch } from '../../model/patient/patient-search';

@Component({
  selector: 'app-patient-bottom-sheet-component',
  templateUrl: 'patient-bottom-sheet.component.html',
  styleUrls: ['./patient-botton-sheet.component.css']
})
export class PatientBottonSheetComponent {

  patients: PatientSearch[];

  constructor(private bottomSheetRef: MatBottomSheetRef<PatientBottonSheetComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public data: PatientSearch[]) {
    this.patients = this.data;
  }

  createPatient(): void {
    const response = new PatientBottonSheetResponse();
    response.create = true;
    this.bottomSheetRef.dismiss(response);
    event.preventDefault();
  }

  selectEditPatient(patient: PatientSearch): void {
    const response = new PatientBottonSheetResponse();
    response.patientEditId = patient.Id;
    this.bottomSheetRef.dismiss(response);
    event.preventDefault();
  }

  selectPatient(patient: PatientSearch): void {
    const response = new PatientBottonSheetResponse();
    response.patient = patient;
    this.bottomSheetRef.dismiss(response);
    event.preventDefault();
  }

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}

export class  PatientBottonSheetResponse {
  public create: boolean;
  public patient: PatientSearch;
  public patientEditId?: number;
}
